import posthog from "posthog-js";
import { sanitizeEvent, telemetryError } from "@ramirotw/telemetry";

const token = import.meta.env.VITE_POSTHOG_PROJECT_TOKEN?.trim();
const host = import.meta.env.VITE_POSTHOG_HOST?.trim();
const enabled = Boolean(token && host);

export function initTelemetry(): void {
  if (!token || !host) {
    if (import.meta.env.DEV) {
      console.warn(
        "VITE_POSTHOG_PROJECT_TOKEN / VITE_POSTHOG_HOST variable required by PostHog is missing or un-configured, this causes events to be silently missed. This error stops appearing once configured"
      );
    }
    return;
  }

  posthog.init(token, {
    api_host: host,
    ui_host: import.meta.env.VITE_POSTHOG_UI_HOST,
    defaults: "2026-05-30",
    capture_pageview: "history_change",
    capture_exceptions: {
      capture_unhandled_errors: true,
      capture_unhandled_rejections: true,
      capture_console_errors: false,
    },
    autocapture: { css_selector_allowlist: ["[data-analytics]"], dom_event_allowlist: ["click"] },
    mask_all_text: true,
    mask_all_element_attributes: true,
    disable_session_recording: true,
    person_profiles: "identified_only",
    ip: false,
    before_send: (event) => (event ? sanitizeEvent(event) : null),
    loaded: (client) =>
      client.register({
        environment: import.meta.env.VITE_APP_ENV || import.meta.env.MODE,
        service: "facturador-web",
        release: import.meta.env.VITE_APP_RELEASE || "local",
      }),
  });
}

// Only the Better Auth user ID: no email, name, or CUIT.
export function identifyUser(userId: string): void {
  if (enabled && posthog.get_distinct_id() !== userId) posthog.identify(userId);
}

export function resetTelemetryUser(): void {
  if (enabled) posthog.reset();
}

export function captureClientError(
  error: unknown,
  operation: string,
  properties: { route?: string; method?: string; status?: number } = {}
): void {
  if (!enabled) return;
  posthog.captureException(telemetryError(error, operation), { operation, ...properties });
}
